// src/pages/MyOrders.js

import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const toKg = (q, u) => (u === "grams" ? (q / 1000).toFixed(2) : q);

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : null;

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState({});

  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${API}/orders/my`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setOrders(res.data);
    } catch (err) {
      console.error("Orders fetch failed:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const toggle = (oid, pid) => {
    setSelected((prev) => {
      const arr = prev[oid] || [];
      return {
        ...prev,
        [oid]: arr.includes(pid)
          ? arr.filter((i) => i !== pid)
          : [...arr, pid],
      };
    });
  };

  const cancelItems = async (oid) => {
    try {
      await axios.put(
        `${API}/orders/cancel-items/${oid}`,
        { itemIds: selected[oid] },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      fetchOrders();
    } catch (err) {
      console.error("Cancel items failed:", err);
    }
  };

  const cancelOrder = async (oid) => {
    try {
      await axios.put(
        `${API}/orders/cancel/${oid}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      fetchOrders();
    } catch (err) {
      console.error("Cancel order failed:", err);
    }
  };

  return (
    <div className="container py-2">
      <div className="text-center mb-3">
        <h4 className="fw-bold mb-1">📦 My Orders</h4>
        <p className="text-muted small mb-0">
          Track, manage and cancel your orders easily
        </p>
      </div>

      {orders.map((o, i) => (
        <div key={o._id} className="card mb-3 shadow-sm border-0 rounded-3">
          <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
            <span className="fw-semibold small">Order #{i + 1}</span>
            <span className={`badge px-2 py-1 rounded-pill small ${
              o.status === "Completed" ? "bg-success text-white"
              : o.status === "Cancelled" ? "bg-danger text-white"
              : "bg-warning text-dark"
            }`}>
              {o.status}
            </span>
          </div>

          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div className="text-muted small">Total Amount</div>
                <div className="fw-bold text-success">₹{o.totalPrice}</div>
                {o.deliveryDate && (
                  <div className="mt-1">
                    {o.status === "Completed" ? (
                      <>
                        <div className="text-muted small">✅ Delivered</div>
                        <div className="fw-bold small" style={{ color: "#28a745" }}>
                          {formatDate(o.deliveryDate)}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="text-muted small">🚚 Expected Delivery</div>
                        <div className="fw-bold text-primary small">
                          {formatDate(o.deliveryDate)}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
              <span className="badge bg-primary-subtle text-primary rounded-pill small">
                {o.products.length} Items
              </span>
            </div>

            <ul className="list-group list-group-flush mb-2">
              {o.products.map((p) => (
                <li
                  key={p._id}
                  className="list-group-item d-flex justify-content-between align-items-center py-2"
                >
                  <div>
                    {o.status === "Placed" && p.status !== "Cancelled" && (
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        onChange={() => toggle(o._id, p._id)}
                      />
                    )}
                    <span className="fw-semibold">{p.name}</span>
                    <div className="text-muted small">
                      {p.quantity} {p.unit}
                    </div>
                    {p.status === "Cancelled" && (
                      <div className="text-danger small">❌ Cancelled</div>
                    )}
                  </div>
                  <span className="fw-semibold small">
                    {toKg(p.quantity, p.unit)} kg
                  </span>
                </li>
              ))}
            </ul>

            {o.status === "Placed" && !o.deliveryDate && (
              <div className="d-flex flex-wrap gap-2 mt-2">
                <button
                  className="btn btn-outline-danger btn-sm rounded-pill px-3"
                  onClick={() => cancelItems(o._id)}
                >
                  Cancel Selected
                </button>
                <button
                  className="btn btn-danger btn-sm rounded-pill px-3"
                  onClick={() => cancelOrder(o._id)}
                >
                  Cancel Order
                </button>
              </div>
            )}

            {o.status === "Placed" && o.deliveryDate && (
              <div className="alert alert-warning py-1 px-2 mt-2 small mb-0">
                🚫 Cannot Cancel your order.
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyOrders;